export const getMinCharsWarning = (title: string, num: number): string => `${title} must be ${num} characters or longer`
